// extracted by mini-css-extract-plugin
export default {"resource-content-summary":"resource-content-summary__2WWGE","summary":"summary__2HRGo"};